import i18n from 'i18next';
import * as Yup from 'yup';
import { isInsuracePortalUser } from 'globalutils/fmUtils';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;

export const validationlist = {
  type: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  name: Yup.string().required(i18n.t('common.fieldRequiredMessage')).max(10, i18n.t('common.validName')),
  esn: Yup.string().when(['trackingDevice'], {
    is: (value) => !!value?.value,
    then: Yup.string().required('common.fieldRequiredMessage'),
    otherwise: Yup.string(),
  }),
  ...(layout !== 'Clutch' && {
    next_maintenance_date: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  }),
  ...((layout !== 'Clutch' || checkServiceProvider('schema_layout_provider', window.$environment?.SERVICE_PROVIDER, false)) && {
    make: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
    model: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  }),
  ...(layout === 'Clutch' && {
    company: isInsuracePortalUser() ? Yup.string().required('common.fieldRequiredMessage') : Yup.string(),
  }),
};
